import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zichanbaobiao",
  "use": "icon-zichanbaobiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zichanbaobiao\"><path d=\"M778.5 159.5h-533c-35.2 0-64 28.8-64 64v576c0 35.2 28.8 64 64 64h533c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64z m0 639.9l-0.1 0.1H245.6l-0.1-0.1V223.6l0.1-0.1h532.8l0.1 0.1v575.8zM679.2 330L554.5 445c-12.2 11.3-31 11.3-43.3 0.1l-52.8-48.3-70.3 64.3c-6.1 5.6-13.9 8.4-21.6 8.4-8.7 0-17.3-3.5-23.6-10.4-11.9-13-11-33.3 2-45.2l91.9-84c12.2-11.2 31-11.2 43.2 0l52.7 48.2L635.8 283c13-12 33.2-11.2 45.2 1.8s11.2 33.2-1.8 45.2zM690 557c0 17.7-14.3 32-32 32H366c-17.7 0-32-14.3-32-32s14.3-32 32-32h292c17.7 0 32 14.3 32 32z m-75 128c0 17.7-14.3 32-32 32H367c-17.7 0-32-14.3-32-32s14.3-32 32-32h216c17.7 0 32 14.3 32 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zichanbaobiao.svg
// module id = knVC
// module chunks = 167